export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  DEAL_STAGE_CHANGED: ['i-lucide-git-branch-plus', 'text-n-blue-11'],
  DEAL_TASK_DUE: ['i-lucide-alarm-clock', 'text-n-amber-11'],
  DEAL_TASK_ASSIGNED: ['i-lucide-list-checks', 'text-n-blue-11'],
  DEAL_ROTTING: ['i-lucide-hourglass', 'text-n-amber-11'],
  DEAL_ASSIGNMENT: ['i-lucide-user-check', 'text-n-blue-11'],
};
